import React from "react";
import { Button } from "../../components/Button";
import { Loop } from "../../components/Loop";
import { Header } from "../../components/Header";
// import { Helmet } from "react-helmet";
import { BlockTry } from "../../blocks/common-blocktry";
import "./styles.less";
import { Link } from "../../components/Link";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { tryNow } from "../../utils";
import { CommonLinkPage } from "../../blocks/common-link-page";
import { Footer } from "../../components/Footer";
import { HomeTryOn } from "../../blocks/home-try-on";
import { CommonPageLink } from "../../blocks/common-page-link";

export const AdvancePage = () => {
  const nav = useNavigate();
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  const securityList = [
    {
      imgurl: "//files.authing.co/authing-website/icon-security-default.svg",
      text: `${t("advantage.security.item0")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/icon-encryption-default.svg",
      text: `${t("advantage.security.item1")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/icon-jwt-default.svg",
      text: `${t("advantage.security.item2")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/icon-rabc-default.svg",
      text: `${t("advantage.security.item3")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/icon-iso-default.svg",
      text: `${t("advantage.security.item4")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/icon-cooperation-default.svg",
      text: `${t("advantage.security.item5")}`,
    },
  ];
  const performanceList = [
    {
      title: `${t("advantage.performance.item-one.title")}`,
      items: [
        `${t("advantage.performance.item-one.list-one")}`,
        `${t("advantage.performance.item-one.list-two")}`,
      ],
    },
    {
      title: `${t("advantage.performance.item-two.title")}`,
      items: [
        `${t("advantage.performance.item-two.list-one")}`,
        `${t("advantage.performance.item-two.list-two")}`,
        `${t("advantage.performance.item-two.list-three")}`,
        `${t("advantage.performance.item-two.list-four")}`,
        `${t("advantage.performance.item-two.list-five")}`,
      ],
    },
  ];
  const productivityList = [
    {
      order: "01",
      title: `${t("advantage.productive.item-one.title")}`,
      content: `${t("advantage.productive.item-one.subtitle")}`,
    },
    {
      order: "02",
      title: `${t("advantage.productive.item-two.title")}`,
      content: `${t("advantage.productive.item-two.subtitle")}`,
    },
    {
      order: "03",
      title: `${t("advantage.productive.item-three.title")}`,
      content: `${t("advantage.productive.item-three.subtitle")}`,
    },
    {
      order: "04",
      title: `${t("advantage.productive.item-four.title")}`,
      content: `${t("advantage.productive.item-four.subtitle")}`,
    },
    {
      order: "05",
      title: `${t("advantage.productive.item-five.title")}`,
      content: `${t("advantage.productive.item-five.subtitle")}`,
    },
    {
      order: "06",
      title: `${t("advantage.productive.item-six.title")}`,
      content: `${t("advantage.productive.item-six.subtitle")}`,
    },
    {
      order: "07",
      title: `${t("advantage.productive.item-seven.title")}`,
      content: `${t("advantage.productive.item-seven.subtitle")}`,
    },
    {
      order: "08",
      title: `${t("advantage.productive.item-eight.title")}`,
      content: `${t("advantage.productive.item-eight.subtitle")}`,
    },
  ];
  // const extendList = [
  //   {
  //     imgurl: "//files.authing.co/authing-website/advance-icon-export.svg",
  //     title: `${t("advantage.productive.item-one.title")}`,
  //     content: `${t("advantage.productive.item-one.subtitle")}`,
  //   },
  //   {
  //     imgurl: "//files.authing.co/authing-website/advance-icon-export.svg",
  //     title: `${t("advantage.productive.item-two.title")}`,
  //     content: `${t("advantage.productive.item-two.subtitle")}`,
  //   },
  //   {
  //     imgurl: "//files.authing.co/authing-website/advance-icon-export.svg",
  //     title: `${t("advantage.productive.item-three.title")}`,
  //     content: `${t("advantage.productive.item-three.subtitle")}`,
  //   },
  // ];
  return (
    <div className="advance-page">
      <Header mode={"light"} />
      <section>
        <div className="advance-banner-warp">
          <div className="advance-banner">
            <div className="inner">
              <div className="content">
                <div className="headline">{t("advantage.banner.title")}</div>
                <div className="subline">{t("advantage.banner.subtitle")}</div>
                <div className="button" onClick={tryNow}>
                  {t("common.button.try-now")}
                </div>
              </div>
            </div>
            <div className="banner-bg">
              <img
                src={"//files.authing.co/authing-website/advance-banner.jpg"}
                alt="authing advance banner"
              />
            </div>
          </div>
          <div className="bg-color"></div>
        </div>
      </section>

      <section>
        <div className="advance-security">
          <div className="inner">
            <div className="top">
              <div className="headline">{t("advantage.security.title")}</div>
              <div className="subline">{t("advantage.security.subtitle")}</div>
            </div>
            <div className="features">
              {securityList.map((item) => {
                return (
                  <div className="item">
                    <div>
                      <div className="icon">
                        <img src={item.imgurl} alt="authing icon" />
                      </div>
                      <div className="text">{item.text}</div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="button-warp">
              <Button
                onClick={() => {
                  nav("/security");
                }}
              >
                {t("common.button.see-more")}
              </Button>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="advance-performance">
          <div className="inner">
            <div className="top">
              <div className="headline">{t("advantage.performance.title")}</div>
            </div>
            <div className="features">
              {performanceList.map((item) => {
                return (
                  <div className="card-item">
                    <div className="title">{item.title}</div>
                    <div className="itemwrap">
                      <div className="items">
                        {item.items.map((i) => {
                          return (
                            <div className="item">
                              <span className="icon-label">
                                <img
                                  src={
                                    "//files.authing.co/authing-website/icon-label.svg"
                                  }
                                  alt="authing icon"
                                />
                              </span>
                              <span>{i}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="advance-product">
          <div className="inner">
            <div className="top">
              <div className="headline">{t("advantage.productive.title")}</div>
            </div>
            <div className="features">
              <div className="card-warp">
                {productivityList.map((item) => {
                  return (
                    <div className="card-item">
                      <div className="order">{item.order}</div>
                      <div className="title">{item.title}</div>
                      <div className="content">{item.content}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="advance-custom">
          <div className="inner">
            <div className="top">
              <div className="headline">{t("advantage.extend.title")}</div>
            </div>
            <div className="card-block">
              <div className="card advance-card-one">
                <div className="title-warp">
                  <div className="icon">
                    <img
                      src={
                        "//files.authing.co/authing-website/advance-icon-export.svg"
                      }
                      alt="authing icon export"
                    />
                  </div>
                </div>
                <div className="content">
                  {t("advantage.extend.item-one.content")}
                </div>
              </div>

              <div className="card advance-card-two">
                <div className="title-warp">
                  <div className="icon">
                    <img
                      src={
                        "//files.authing.co/authing-website/advance-icon-protocol.svg"
                      }
                      alt="authing icon protocol"
                    />
                  </div>
                </div>
                <div className="content">
                  {t("advantage.extend.item-two.content")}
                </div>
              </div>

              <div className="card advance-card-tree">
                <div className="title-warp">
                  <div className="icon">
                    <img
                      src={
                        "//files.authing.co/authing-website/advance-icon-custom.svg"
                      }
                      alt="authing custom"
                    />
                  </div>
                </div>
                <div className="content">
                  {t("advantage.extend.item-three.content")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="advance-developer">
          <div className="inner">
            <div className="top">
              <div className="headline">{t("advantage.developer.title")}</div>
            </div>
            <div className="content">
              <div className="content-left">
                <p>
                  {t("advantage.developer.descript-one.content")}
                  <Link href="https://github.com/authing" rel="nofollow">
                    {t("advantage.developer.descript-one.link")}
                  </Link>
                </p>
              </div>
              <div className="content-right">
                <img
                  src={"//files.authing.co/authing-website/advance-one.svg"}
                  alt="authing advantage"
                />
              </div>
            </div>
            {/* <div className="loop-warp">
              <Loop />
            </div> */}
            <div className="content">
              <div className="content-left" style={{ marginTop: 30 }}>
                <p>
                  {t("advantage.developer.descript-two.content")}
                  <Link href="https://solidproject.org/">
                    {t("advantage.developer.descript-two.link")}
                  </Link>
                </p>
              </div>
              <div className="content-right" style={{ marginRight: 100 }}>
                <img
                  src={"//files.authing.co/authing-website/advance-two.svg"}
                  alt="authing advantage"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="advance-deploy">
          <div className="inner">
            <div className="top">
              <div className="headline">{t("advantage.deployment.title")}</div>
            </div>
            <div className="content">
              <div className="content-left">
                <img
                  src={"//files.authing.co/authing-website/advance-tree.svg"}
                  alt="authing advantage deployment"
                />
              </div>
              <div className="content-right">
                {t("advantage.deployment.content")}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="advance-ourserve">
          <div className="inner">
            <div className="top">
              <div className="headline">{t("advantage.success.title")}</div>
            </div>
            <div className="content">
              <div className="content-left">
                <p>{t("advantage.success.content-one")}</p>
                <p>{t("advantage.success.content-two")}</p>
              </div>
              <div className="content-right">
                <img
                  src={"//files.authing.co/authing-website/advance-four.svg"}
                  alt="authing advantage success"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <CommonPageLink pagesLink={pagesLink} />
      <div className="advantagePage-homeTryOn-bg">
        <HomeTryOn />
      </div>
      <Footer />
    </div>
  );
};
